import { render, staticRenderFns } from "./Launcher.vue?vue&type=template&id=ddf869e6&scoped=true&"
import script from "./Launcher.vue?vue&type=script&lang=js&"
export * from "./Launcher.vue?vue&type=script&lang=js&"
import style0 from "./Launcher.vue?vue&type=style&index=0&id=ddf869e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf869e6",
  null
  
)

export default component.exports